module.exports = __webpack_public_path__ + "static/media/sort-numeric-down.ee89e927.svg";